<template>
  <label
    v-if="text"
    class="field__label"
  >
    {{ text }}
  </label>
</template>

<script>

export default {
  name: 'InputfieldLabel',
  props: {
    text: {
      type: String,
      required: false,
      default () {
        return ''
      },
    },
  },
}

</script>

<style lang="scss" scoped>

</style>
